import React, { useState, useEffect } from "react";
import SvgWishes from "../components/WishesSvg";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { db } from "../firebase";
import { ref, set } from "firebase/database";

import line from "../assets/line.png";
import WishesSection from "../components/WishesSection";

export default function Wishes() {
  const color = "#565260";
  const svg =
    "M0,192L48,170.7C96,149,192,107,288,90.7C384,75,480,85,576,117.3C672,149,768,203,864,234.7C960,267,1056,277,1152,266.7C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z";

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  const [kehadiran, setKehadiran] = useState("");
  const [nama, setNama] = useState("");
  const [ucapan, setUcapan] = useState("");

  useEffect(() => {
    // setNama(query.get("hihi"));
  }, []);

  const submit = () => {
    let errorMsg;

    if (nama.length < 1) {
      errorMsg = "Mohon untuk mengisi nama terlebih dahulu";
    } else if (kehadiran.length < 1) {
      errorMsg = "Mohon untuk mengisi konfirmasi kehadiran terlebih dahulu";
    } else if (ucapan.length < 1) {
      errorMsg = "Mohon untuk mengisi doa dan ucapan";
    } else {
      errorMsg = `Hai ${nama}. Moonmaap ni tapi eventnya sudah selesai :)`;
    }

    if (errorMsg) {
      Swal.fire({
        text: errorMsg,
        icon: "error",
        confirmButtonText: "Oke deh",
      });
      return;
    }

    // const date = Date.now();
    // set(ref(db, `/${date}`), {
    //   nama,
    //   kehadiran,
    //   ucapan,
    // })
    //   .then(() => {
    //     setNama("");
    //     setUcapan("");
    //     setKehadiran("");
    //     Swal.fire("Yeay!", "Doa dan ucapan telah terkirim!", "success");
    //   })
    //   .catch(() => {
    //     Swal.fire({
    //       text: errorMsg,
    //       icon: "Gagal mengirim pesan :(",
    //       confirmButtonText: "Oke deh",
    //     });
    //   });
  };

  return (
    <>
      <SvgWishes color={color} svg={svg} />
      <div style={{ marginTop: -5 }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill={color} fill-opacity="0" d={svg}></path>
        </svg>
        <div
          style={{
            width: "100%",
            backgroundColor: color,
          }}
        >
          <div
            style={{
              padding: "40px 20px 40px 20px",
            }}
          >
            <p
              className="garamond-font"
              style={{
                fontSize: 15,
                color: "whitesmoke",
                fontWeight: "100",
                marginBottom: 30,
              }}
            >
              Merupakan suatu kehormatan dan kebahagiaan bagi kami apabila
              Bapak/Ibu/Saudara/i berkenan hadir untuk memberikan do’a restu
              kepada kedua mempelai.
            </p>

            <i
              className="garamond-font"
              style={{
                fontSize: 15,
                color: "whitesmoke",
                fontWeight: "lighter",
              }}
            >
              Wassalamu'alaikum Warahmatullahi Wabarakatuh
            </i>
            <p
              className="garamond-font"
              style={{
                fontSize: 15,
                color: "whitesmoke",
                fontWeight: "100",
                marginTop: 10,
                marginBottom: 40,
              }}
            >
              Turut berbahagia, <br />
              Segenap keluarga besar
            </p>
            <p
              className="playball-font"
              style={{
                marginBottom: 5,
                fontSize: 30,
                color: "#F5D28D",
                textShadow: "5px 5px 11px rgba(15,16,24,0.75)",
              }}
            >
              Vita & Ganang
            </p>
            <img src={line} width={200} style={{ marginBottom: 50 }} />
            {/* ucapan */}
            <div className="input-container">
              <label className="label">Nama :</label>
              {/* <i
                className="label"
                style={{
                  color: "#F5D28D",
                  fontSize: 20,
                  margin: "0px 0px 20px",
                }}
              >
                {query.get("hihi")}
              </i> */}
              <input
                className="wishes-input-name"
                placeholder="ketik nama disini..."
                value={nama}
                onChange={(e) => setNama(e.target.value)}
              />
              <label className="label">konfirmasi kehadiran :</label>
              <div
                style={{ display: "flex", alignItems: "center", marginTop: 5 }}
              >
                <input
                  type="radio"
                  value="hadir"
                  checked={kehadiran === "hadir"}
                  onChange={(e) => setKehadiran(e.target.value)}
                />
                <label
                  className="label"
                  style={{
                    fontSize: 18,
                    marginLeft: 8,
                    color: kehadiran === "hadir" ? "#F5D28D" : "white",
                  }}
                >
                  Ya, saya akan hadir
                </label>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", marginTop: 5 }}
              >
                <input
                  type="radio"
                  value="tidak hadir"
                  checked={kehadiran === "tidak hadir"}
                  onChange={(e) => setKehadiran(e.target.value)}
                />
                <label
                  className="label"
                  style={{
                    fontSize: 18,
                    marginLeft: 8,
                    color: kehadiran === "tidak hadir" ? "#F5D28D" : "white",
                  }}
                >
                  Maaf, saya tidak bisa datang
                </label>
              </div>
              <input
                className="wishes-input"
                placeholder="ketik doa dan ucapan disini..."
                value={ucapan}
                onChange={(e) => setUcapan(e.target.value)}
              />
            </div>
            <button className="send-wish-button" onClick={submit}>
              <i class="fas fa-paper-plane" style={{ marginRight: 10 }} />
              Kirim doa dan ucapan
            </button>
            <WishesSection />
          </div>
        </div>
      </div>
    </>
  );
}
